import * as tslib_1 from "tslib";
import { jsonMember, jsonObject } from "typedjson";
let BdpkDeveloperEnv = class BdpkDeveloperEnv {
};
tslib_1.__decorate([
    jsonMember({ constructor: Number, emitDefaultValue: false, isRequired: true }),
    tslib_1.__metadata("design:type", Number)
], BdpkDeveloperEnv.prototype, "id", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnv.prototype, "name", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnv.prototype, "description", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnv.prototype, "link", void 0);
tslib_1.__decorate([
    jsonMember({ constructor: String, emitDefaultValue: false, isRequired: false }),
    tslib_1.__metadata("design:type", String)
], BdpkDeveloperEnv.prototype, "imagePath", void 0);
BdpkDeveloperEnv = tslib_1.__decorate([
    jsonObject
], BdpkDeveloperEnv);
export { BdpkDeveloperEnv };
